import React, { useCallback, useState } from 'react';
import useArtifactPreviewHelper from '../../../artifactPreviewHelper';
import { API_FILE_TYPE } from '../../../constants';
import { InputLoader } from 'framework/ui/mui-builder';
import { Tooltip } from 'framework/ui/mui-builder';
import { FileName } from 'framework/documentStorage';

const getArtifactsIcon = (type: string) => {
  const artifactType = type.toLowerCase();

  // @ts-ignore
  return API_FILE_TYPE[artifactType] ? API_FILE_TYPE[artifactType].category.icon : API_FILE_TYPE.default.category.icon;
};

export type ArtifactType = { id: string; hasPreview?: boolean; isHasPreview?: boolean; type: string; title: string };

type ArtifactPreviewWrapperProps = {
  artifact: ArtifactType;
  handleOpenPreview: () => Promise<void> | void;
  handleDownload: () => void;
  hasIcon?: boolean;
  customFileName?: string | React.ReactElement;
};

const ArtifactPreviewWrapper = ({
  artifact,
  handleOpenPreview,
  handleDownload,
  hasIcon = true,
  customFileName,
}: ArtifactPreviewWrapperProps) => {
  const { id, hasPreview, isHasPreview, type, title } = artifact;
  const { isPreviewAvailable } = useArtifactPreviewHelper();
  const previewAvailable = isPreviewAvailable(type);
  const elementId = `view-preview-button-${id}`;
  const isShowTooltip = previewAvailable && (!hasPreview || !isHasPreview);
  const [loading, setLoading] = useState(false);

  const handleClick = useCallback(async () => {
    if (previewAvailable) {
      if ((hasPreview || isHasPreview) && !loading) {
        setLoading(true);
        await handleOpenPreview();
        setLoading(false);
      }
    } else {
      handleDownload();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, hasPreview, previewAvailable]);

  return (
    <Tooltip title={isShowTooltip ? 'Preview is not yet ready, please wait' : ''} placement="right" id={elementId}>
      <button key={id} type="button" onClick={handleClick} id={elementId} data-testid="artifact-open-preview">
        {hasIcon && (
          <span className="files-list__files-icon">
            <img src={getArtifactsIcon(type)} alt="" title={title} data-testid="artifact-doc" />
          </span>
        )}
        {customFileName || <FileName title={title} />}
        {loading ? <InputLoader className="files-list__files-loader" /> : null}
      </button>
    </Tooltip>
  );
};

export default ArtifactPreviewWrapper;
